import $http from '@Config/axios';

const prefix = 'relatorios';

export const RelatorioPresenter = {
	estoquePaciente: () => $http.get(`${prefix}/estoquePaciente`)
};
